import { BulkSuccessDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-types";
import { Stack, SvgIcon, Typography } from "@mui/material";
import { useAppDispatch } from "@store/store-helper";
import {
  setBulkActionName,
  setInitialFetchingItems,
} from "@store/table/table-slice";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { Dialog, green, CheckmarkCircleFillIcon } from "@flat-ui";

interface Props {
  /** The content of the dialog */
  dialogContent: BulkSuccessDialogContent;
}

/** Show success message if all the bulk actions are successful */
export function BulkSuccessDialog({ dialogContent }: Props): JSX.Element {
  const dispatch = useAppDispatch();

  return (
    <Dialog
      open={true}
      title={
        <Stack direction="row" alignItems="center">
          <SvgIcon
            inheritViewBox
            component={CheckmarkCircleFillIcon}
            sx={{
              ...getSvgColoredIconCss(green[700]),
              height: "28px",
              width: "28px",
              mr: "12px",
            }}
          />
          {dialogContent.title}
        </Stack>
      }
      onConfirm={() => {
        dispatch(setBulkActionName(null));
        dispatch(setInitialFetchingItems([]));
      }}
      confirmText="Done"
    >
      <Typography
        sx={{
          fontSize: "14px",
        }}
      >
        {dialogContent.description}
      </Typography>
    </Dialog>
  );
}
